import { g as e } from "./index767.mjs";
var g = e, r = g.navigator, a = r && r.userAgent, t = a ? String(a) : "";
export {
  t as e
};
